import React from "react";

import QuickAddEditFranchise from "../components/Franchise/QuickAddEditFranchise";
import { Container } from "react-bootstrap";

const FranchisePage = () => {
  return (
    <Container>
      <QuickAddEditFranchise />
    </Container>
  );
};

export default FranchisePage;
